module.exports = __webpack_public_path__ + "img/volume_off.58c65a9f.svg";